<template>
  <div class="d3-chart">
    <v-container id="d3-chart-container" fluid grid-list-md fill-height text-xs-center>
      <v-layout wrap align-center>
        <v-flex xs12>
          <h3 class="font-weight-bold">BRI FINANCIAL ARCHITECTURE</h3>
        </v-flex>

        <v-flex xs12 md9 xl10>
          <v-layout row wrap fill-height justify-start>
            <!-- the chart -->
            <v-flex class="chart-container" xs12>
              <div id="chart"></div>
              <v-card v-show="isPopup" class="popup" :class="{ 'popup-center': this.activeBtn !== 'all' }" :style="{ left: `${popupProps.x}px`, top: `${popupProps.y}px`, }">
                <v-card-title v-show="isBubblePopup" primary-title>
                  <h3 class="popup-title mb-0 text-xs-left">{{ popupProps.title }}</h3>
                </v-card-title>
                <v-card-text v-show="isBubblePopup" class="py-0">
                  <p class="popup-amount text-xs-left">Amount: {{ popupProps.amount === 0 ? 'Pending' : `US $ ${popupProps.amount} Billion` }}</p>
                </v-card-text>
                <v-card-text :class="{'pt-0': isBubblePopup}">
                  <p class="popup-description text-xs-left">{{ popupProps.description }}</p>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex style="margin: auto 0 auto 0;" xs12 md3 xl2>
          <v-flex mb-2 xs12>
            <v-btn-toggle style="display: grid;" mandatory>
              <v-btn
                @click="onBtnClicked('all')"
                color="white"
                :ripple="false"
                class="btn--plain"
                :class="{ 'v-btn--active': activeBtn === 'all' }">
                All Funds
              </v-btn>
              <v-btn
                @click="onBtnClicked('category')"
                color="white"
                :ripple="false"
                class="btn--plain"
                :class="{ 'v-btn--active': activeBtn === 'category' }">
                Funds by Category
              </v-btn>
              <v-btn
                @click="onBtnClicked('type')"
                color="white"
                :ripple="false"
                class="btn--plain"
                :class="{ 'v-btn--active': activeBtn === 'type' }">
                Funds by Type
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex mb-2 xs12 hidden-sm-and-down>
            <v-card class="legend-container text-xs-left">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <h3 class="caption font-weight-bold legend-title">Amount (US $ Billion)</h3>
                  </v-flex>
                  <v-flex xs12>
                    <div class="big-bubble-legend">
                      <hr class="dotted-line" />
                    </div>
                    <div class="sm-bubble-legend">
                      <hr class="dotted-line" />
                    </div>
                    <div class="caption text-legend-480">480</div>
                    <div class="caption text-legend-pending">Pending</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <v-card class="legend-container text-xs-left">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <h3 class="caption font-weight-bold legend-title">Category</h3>
                  </v-flex>
                  <v-flex xs6 md12>
                    <v-layout row wrap>
                      <v-flex class="circle-legend-container" xs2>
                        <div class="circle" style="background-color: #5580C8;"></div>
                      </v-flex>
                      <v-flex xs10 class="caption">
                        Multilateral Development Bank
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex class="circle-legend-container" xs2>
                        <div class="circle" style="background-color: #8BD8B8;"></div>
                      </v-flex>
                      <v-flex xs10 class="caption">
                        Regional Funds
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex class="circle-legend-container" xs2>
                        <div class="circle" style="background-color: #5BA694;"></div>
                      </v-flex>
                      <v-flex xs10 class="caption">
                        Bilateral Funds
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex class="circle-legend-container" xs2>
                        <div class="circle" style="background-color: #BF7CA8;"></div>
                      </v-flex>
                      <v-flex xs10 class="caption">
                        Investment Funds
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 md12>
                    <v-layout row wrap>
                      <v-flex class="circle-legend-container" xs2>
                        <div class="circle" style="background-color: #927F9B;"></div>
                      </v-flex>
                      <v-flex xs10 class="caption">
                        Big 4 State-owned Commercial Banks
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex class="circle-legend-container" xs2>
                        <div class="circle" style="background-color: #c2a5cf;"></div>
                      </v-flex>
                      <v-flex xs10 class="caption">
                        Policy Banks
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex class="circle-legend-container" xs2>
                        <div class="circle" style="background-color: #90B9E9;"></div>
                      </v-flex>
                      <v-flex xs10 class="caption">
                        International Bank
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex class="circle-legend-container" xs2>
                        <div class="circle" style="background-color: #255868;"></div>
                      </v-flex>
                      <v-flex xs10 class="caption">
                        Sovereign wealth funds and institutions
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import * as d3 from 'd3';
import { mapGetters } from 'vuex';

export default {
  name: 'D3Clusters',
  data() {
    return {
      rawData: null,
      data: null,
      clusterData: { category: null, type: null },
      simulation: null,
      settings: {
        w: 0,
        h: 0,
        minRadius: 9,
        maxRadius: 80,
        forceStrengths: 0.01,
      },
      theContainer: {
        svg: null,
        gBubbles: null,
        gClusters: null,
        bubbleContainers: null,
        bubbles: null,
        texts: null,
        clusterTexts: null,
      },
      popupProps: { title: '', amount: '', description: '', x: 0, y: 0 },
      isPopup: false,
      isBubblePopup: false,
      colors: null,
      activeBtn: 'all',
    };
  },
  async mounted() {
    // Load the data
    this.rawData = await d3.csv('/data/finance/bri-finance.csv');
    this.generateData(this.rawData);

    // Dimensions declaration
    const $d3Chart = document.querySelector('.d3-chart');
    this.settings.w = $d3Chart.offsetWidth;
    this.settings.h = $d3Chart.offsetHeight;

    this.colors = d3
      .scaleOrdinal()
      .domain(d => d.category)
      .range(['#5BA694', '#255868', '#c2a5cf', '#5580C8', '#90B9E9', '#BF7CA8', '#8BD8B8', '#927F9B']);

    this.simulation = d3
      .forceSimulation()
      .velocityDecay(0.2)
      .force(
        'x',
        d3
          .forceX()
          .strength(this.settings.forceStrengths)
          .x(this.centerCoor.x)
      )
      .force(
        'y',
        d3
          .forceY()
          .strength(this.settings.forceStrengths)
          .y(this.centerCoor.y)
      )
      .force('collide', d3.forceCollide(d => d.radius + 1))
      .on('tick', this.ticked);

    this.simulation.stop();

    // Generate the chart
    this.theContainer.svg = d3
      .select('#chart')
      .append('svg')
      .attr('preserveAspectRatio', 'xMidYMid meet')
      .attr('viewBox', `0 0 ${this.settings.w} ${this.settings.h}`);
    this.theContainer.gBubbles = this.theContainer.svg.append('g').attr('class', 'g-bubbles');

    this.theContainer.gClusters = this.theContainer.svg.append('g').attr('class', 'g-clusters');

    this.theContainer.bubbleContainers = this.theContainer.gBubbles
      .selectAll('g')
      .data(this.nodes)
      .enter()
      .append('g')
      .attr('class', 'bubble-container');

    this.theContainer.bubbleContainers.on('mouseover', this.onBubblesHovered).on('mouseout', this.onMouseOut);

    this.theContainer.bubbles = this.theContainer.bubbleContainers
      .append('circle')
      .attr('r', 0)
      .attr('fill', d => this.colors(d.categoryCluster))
      .attr('fill-opacity', 0.7)
      .attr('stroke', d => this.colors(d.categoryCluster));

    this.theContainer.texts = this.theContainer.bubbleContainers
      .append('text')
      .attr('text-anchor', 'middle')
      .attr('fill', '#fff')
      .attr('font-family', "'LL Akkurat Pro', Helvetica, sans-serif")
      .attr('font-size', 16)
      .attr('line-height', 15)
      .attr('display', d => (+d.radius > 20 ? 'block' : 'none'))
      .style('opacity', 0)
      .text(d => d.shortName);

    this.theContainer.bubbles
      .transition()
      .duration(2000)
      .attr('r', d => d.radius);

    this.theContainer.texts
      .transition()
      .delay(1500)
      .transition()
      .duration(500)
      .style('opacity', 1);

    d3.select('.popup')
      .on('mouseover', this.onPopupHovered)
      .on('mouseout', this.onMouseOut);

    this.simulation.nodes(this.nodes);

    this.groupBubbles();
  },
  updated() {
    this.simulation.nodes(this.nodes).on('tick', this.ticked);
  },
  computed: {
    ...mapGetters('view', ['step']),
    centerCoor() {
      return {
        x: this.settings.w / 2,
        y: this.settings.h * 0.4,
      };
    },
    splitCenterCoors() {
      return {
        bubbles: [
          { x: this.settings.w / 6, y: this.settings.h * 0.2 },
          { x: this.settings.w / 2, y: this.settings.h * 0.17 },
          { x: (5 * this.settings.w) / 6, y: this.settings.h * 0.17 },
          { x: this.settings.w / 6, y: this.settings.h * 0.52 },
          { x: this.settings.w / 2, y: this.settings.h * 0.52 },
          { x: (5 * this.settings.w) / 6, y: this.settings.h * 0.52 },
          { x: this.settings.w / 6, y: this.settings.h * 0.85 },
          { x: this.settings.w / 2, y: this.settings.h * 0.85 },
        ],
        texts: [
          { x: this.settings.w / 6, y: this.settings.h * 0.05 },
          { x: this.settings.w / 2, y: this.settings.h * 0.05 },
          { x: (5 * this.settings.w) / 6, y: this.settings.h * 0.05 },
          { x: this.settings.w / 6, y: this.settings.h * 0.4 },
          { x: this.settings.w / 2, y: this.settings.h * 0.4 },
          { x: (5 * this.settings.w) / 6, y: this.settings.h * 0.4 },
          { x: this.settings.w / 6, y: this.settings.h * 0.7 },
          { x: this.settings.w / 2, y: this.settings.h * 0.7 },
        ],
      };
    },
    nodes() {
      const minAmount = d3.min(this.data, d => +d.amount);
      const maxAmount = d3.max(this.data, d => +d.amount);

      const radiusScale = d3
        .scaleSqrt()
        .domain([minAmount, maxAmount])
        .range([this.settings.minRadius, this.settings.maxRadius]);

      const nodes = this.data.map(d => {
        return {
          ...d,
          radius: radiusScale(d.amount),
          x: Math.random() * 900,
          y: Math.random() * 800,
        };
      });

      nodes.sort((a, b) => b.amount - a.amount);

      return nodes;
    },
  },
  watch: {
    step(newVal) {
      this.handleCluster(newVal);
    },
  },
  methods: {
    ticked() {
      this.theContainer.bubbleContainers.attr('transform', d => `translate(${+d.x}, ${+d.y})`);
    },
    nodeCategoryX(d) {
      return this.splitCenterCoors.bubbles[d.categoryCluster].x;
    },
    nodeCategoryY(d) {
      return this.splitCenterCoors.bubbles[d.categoryCluster].y;
    },
    nodeTypeX(d) {
      return this.splitCenterCoors.bubbles[d.typeCluster].x;
    },
    nodeTypeY(d) {
      return this.splitCenterCoors.bubbles[d.typeCluster].y;
    },
    groupBubbles() {
      this.settings.forceStrengths = 0.01;
      this.simulation.force(
        'x',
        d3
          .forceX()
          .strength(this.settings.forceStrengths)
          .x(this.centerCoor.x)
      );
      this.simulation.force(
        'y',
        d3
          .forceY()
          .strength(this.settings.forceStrengths)
          .y(this.centerCoor.y)
      );
      this.simulation.alpha(1).restart();
    },
    splitBubblesCategory() {
      this.settings.forceStrengths = 0.03;
      this.simulation.force(
        'x',
        d3
          .forceX()
          .strength(this.settings.forceStrengths)
          .x(this.nodeCategoryX)
      );
      this.simulation.force(
        'y',
        d3
          .forceY()
          .strength(this.settings.forceStrengths)
          .y(this.nodeCategoryY)
      );
      this.simulation.alpha(1).restart();
    },
    splitBubblesType() {
      this.settings.forceStrengths = 0.02;
      this.simulation.force(
        'x',
        d3
          .forceX()
          .strength(this.settings.forceStrengths)
          .x(this.nodeTypeX)
      );
      this.simulation.force(
        'y',
        d3
          .forceY()
          .strength(this.settings.forceStrengths)
          .y(this.nodeTypeY)
      );
      this.simulation.alpha(1).restart();
    },
    generateData(rawData) {
      const uniqueCats = [];
      const uniqueTypes = [];

      const lowercasedData = rawData.map(d => {
        return {
          ...d,
          category: d.category.toLowerCase(),
          type: d.type.toLowerCase(),
        };
      });

      const data = lowercasedData.map((d, i) => {
        if (uniqueCats.map(mapObj => mapObj.lowercased).indexOf(d.category) === -1) {
          uniqueCats.push({
            name: rawData[i].category,
            description: d.categoryDescription,
            lowercased: d.category.toLowerCase(),
          });
        }
        if (uniqueTypes.map(mapObj => mapObj.lowercased).indexOf(d.type) === -1) {
          uniqueTypes.push({
            name: rawData[i].type,
            lowercased: d.type.toLowerCase(),
          });
        }

        let categoryCluster = uniqueCats.map(mapObj => mapObj.lowercased).indexOf(d.category);
        let typeCluster = uniqueTypes.map(mapObj => mapObj.lowercased).indexOf(d.type);

        return {
          ...d,
          amount: isNaN(+d.amount) ? 0 : +d.amount,
          category: rawData[i].category,
          categoryCluster,
          type: rawData[i].type,
          typeCluster,
        };
      });

      // Assign the variables
      this.data = data;
      this.clusterData.category = uniqueCats;
      this.clusterData.type = uniqueTypes;
    },
    onBubblesHovered(d) {
      this.popupProps.title = d.name;
      this.popupProps.amount = d.amount;
      this.popupProps.description = d.description;
      let x =
        window.event.clientX - (window.innerWidth * 0.402777777777778 - 50) < 0
          ? 0
          : window.event.clientX - (window.innerWidth * 0.402777777777778 - 50);
      let y = window.event.clientY - 65;

      // this.popupProps.x = x;
      // this.popupProps.y = y;
      this.isPopup = true;
      this.isBubblePopup = true;
      if (this.activeBtn === 'all') {
        this.popupProps.x = x;
        this.popupProps.y = y;
      } else {
        this.popupProps.x = 0;
        this.popupProps.y = 120;
      }
    },
    onClusterHovered(d) {
      if (!d.description) {
        return;
      }
      this.popupProps.title = '';
      this.popupProps.amount = '';
      this.popupProps.description = d.description;
      this.popupProps.x = 0;
      this.popupProps.y = 120;
      this.isPopup = true;
      this.isBubblePopup = false;
    },
    onPopupHovered() {
      if (this.activeBtn === 'all') {
        return;
      }
      this.isPopup = true;
    },
    onMouseOut() {
      this.isPopup = false;
    },
    onBtnClicked(param) {
      this.activeBtn = param;
      if (this.theContainer.clusterTexts !== null) {
        d3.selectAll('.cluster-text').remove();
      }
      if (param === 'all') {
        this.groupBubbles();
      } else {
        let data = null;
        if (param === 'category') {
          this.splitBubblesCategory();
          // Redo the force to make it stronger after colliding
          setTimeout(() => {
            this.splitBubblesCategory();
          }, 800);
          data = this.clusterData.category;
        } else {
          // type
          this.splitBubblesType();
          // Redo the force to make it stronger after colliding
          setTimeout(() => {
            this.splitBubblesType();
          }, 800);
          data = this.clusterData.type;
        }
        this.theContainer.clusterTexts = this.theContainer.gClusters
          .selectAll('g')
          .data(data)
          .enter()
          .append('g')
          .attr('class', 'cluster-text')
          .attr(
            'transform',
            (d, i) => `translate(${this.splitCenterCoors.texts[i].x}, ${this.splitCenterCoors.texts[i].y})`
          )
          .append('text')
          .attr('text-anchor', 'middle')
          .attr('fill', 'rgba(0, 0, 0, 0.8)')
          .attr('font-family', "'LL Akkurat Pro', Helvetica, sans-serif")
          .attr('font-size', 20)
          .attr('line-height', 18)
          .attr('font-weight', 600)
          .style('opacity', 0)
          .text(d => d.name);
        this.theContainer.clusterTexts
          .transition()
          .duration(500)
          .style('opacity', 1);
        this.theContainer.clusterTexts.on('mouseover', this.onClusterHovered).on('mouseout', this.onMouseOut);
      }
    },
    handleCluster(currentStep) {
      switch (currentStep) {
        case '4-1':
          this.onBtnClicked('all');
          break;

        case '4-1-1':
          this.onBtnClicked('category');
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
#d3-chart-container {
  .btn--plain {
    &.v-btn--active, &:hover, &:focus {
      color: #F2784B;

      &:before {
        background-color: transparent;
      }
    }
  }

  .chart-container {
    position: relative;

    .popup {
      position: absolute;
      z-index: 999;
      max-width: 360px;

      .popup-title {
        font-size: 18px;
        line-height: 25px;
        color: rgba(0, 0, 0, 0.7) !important;
      }

      .popup-amount {
        color: #F38063;
        font-weight: 600;
      }

      .popup-description {
        color: rgba(0, 0, 0, 0.7) !important;
        margin: unset;
      }
    }

    .popup.popup-center {
      right: 0;
      margin: auto;
    }
  }

  .legend-container {
    .legend-title {
      font-size: 13px !important;
      line-height: 18px !important;
      color: rgba(0, 0, 0, 0.8) !important;
    }

    .sm-bubble-legend {
      position: absolute;
      top: 137px;
      left: 66px;
      width: 15px;
      height: 15px;
      border: 1px solid;
      border-radius: 50%;
      border-color: rgba(0, 0, 0, 0.4);

      hr.dotted-line {
        position: absolute;
        top: -1px;
        left: 6px;
        width: 60px;
      }
    }

    .big-bubble-legend {
      width: 110px;
      height: 110px;
      border: 1px solid;
      border-radius: 50%;
      border-color: rgba(0, 0, 0, 0.4);

      hr.dotted-line {
        position: absolute;
        top: 42px;
        left: 71px;
        width: 60px;
      }
    }

    hr.dotted-line {
      border: none;
      border-top: 1px dotted rgba(0, 0, 0, 0.4);
      background-image: linear-gradient(to right, #333 10%, rgba(0, 0, 0, 0.4) 0%);
      background-position: top;
      background-size: 10px 1px;
      background-repeat: repeat-x;
      height: 1px;
    }

    .text-legend-480 {
      position: absolute;
      top: 37px;
      left: 150px;
    }

    .text-legend-pending {
      position: absolute;
      top: 134px;
      left: 150px;
    }

    .circle-legend-container {
      padding-top: 7px;

      .circle {
        width: 14px;
        height: 14px;
        border-radius: 50%;
      }
    }
  }
}
</style>
